import CommentsPage from './CommentsPage';

import './comments.scss';

export default CommentsPage;